import { createContext, useContext, useLayoutEffect } from 'react';

// How a page tells Layout.js that it is showing an open conversation.
//
// Below lg an open conversation is one screen tall, and its composer stands
// in the column where Layout floats the assistant button: Layout leaves the
// button out there (`showAssistantFab`). Which of its two views /chat shows
// is the page's own state, and Layout draws the page as `children`, so the
// page has to say. Layout provides the setter of its own flag; a page drawn
// outside Layout has no one to tell.
const OpenConversationContext = createContext(null);

// A bare context provider: it draws no box between <main> and the page.
export const OpenConversationProvider = OpenConversationContext.Provider;

// Called by the page with whether a conversation is open right now. A layout
// effect: Layout draws again before the browser paints, so the conversation
// and the assistant button are never on a phone's screen together. Taken back
// when the conversation closes or the page goes.
export function useOpenConversation(open) {
  const tellLayout = useContext(OpenConversationContext);
  useLayoutEffect(() => {
    if (!open || !tellLayout) return undefined;
    tellLayout(true);
    return () => tellLayout(false);
  }, [open, tellLayout]);
}
